import * as GUEST from './Guest';
import * as ADMIN from './Admin';

export default {
  GUEST,
  ADMIN
};
